/**
 * Feature flag keys registered for SSR evaluation via GrowthBook.
 *
 * Unlike experiments (AllowedExperimentKey), these are simple boolean flags
 * with no per-tenant gating or circuit breaker layers. Targeting is configured
 * entirely in the GrowthBook dashboard (e.g. by environment).
 *
 * Keys must match GrowthBook feature keys exactly (case-sensitive).
 * When GrowthBook is unavailable, `gb.isOn()` returns `false` (safe default).
 */
export enum AllowedFeatureFlagKey {
  USE_COGNITO_AUTH = 'use-cognito-auth',
}
